@if (payment) {
  <div class="flex-fill d-flex flex-column card">
    <div class="btn-toolbar">
      @if (hasChanges()) {
        <button class="btn btn-success me-2" (click)="save()">Save</button>
      }
      @if (hasChanges()) {
        <button class="btn btn-danger" (click)="cancel()">Cancel</button>
      }
      @if (!hasChanges()) {
        <button class="btn btn-primary" (click)="close()">Close</button>
      }
      <!-- <button (click)="saveAndSend()" class="btn btn-primary ms-5 me-2">Save & Send</button> -->
      <!-- <button *ngIf="!hasChanges() && readonly" (click)="printPaymentReceipt()" class="btn btn-primary ms-2">Print Payment</button> -->
      <div class="d-flex ms-auto align-items-center me-3" style="max-width: 250px">
        <label class="mt-2 me-3">Payment Date</label>
        <dx-date-box [(value)]="payment.paymentDate" width="150px"></dx-date-box>
      </div>
    </div>
    <dx-form class="px-3" [formData]="payment" [colCount]="4" validationGroup="invoiceValidationGroup">
      <dxi-item itemType="group" caption="Customer" [disabled]="readOnly">
        @if (customer) {
          <dxi-item>
            <div *dxTemplate>
              <h3 class="mt-0 mb-1">{{ customer.displayName }}</h3>
              <div>{{ customer.billAddress1 }}</div>
              <div>{{ customer.billAddress2 }}</div>
              <div>
                {{ customer.billCity ? customer.billCity + "," : "" }}
                {{ customer.billState }}
                {{ customer.billZip }}
              </div>
            </div>
          </dxi-item>
        }
      </dxi-item>
      <dxi-item itemType="group" caption="Payment Info">
        <dxi-item
          dataField="paymentMethodId"
          [label]="{ text: 'Method' }"
          editorType="dxSelectBox"
          [editorOptions]="{ dataSource: paymentMethods, valueExpr: 'id', displayExpr: 'name', disabled: payment.quickBooksId }"
          >
        </dxi-item>
        <dxi-item dataField="referenceNumber" [editorOptions]="{ disabled: payment.quickBooksId }"></dxi-item>
      </dxi-item>
      <dxi-item itemType="group" caption="Totals">
        <dxi-item [label]="{ text: 'Amount Received' }">
          <div *dxTemplate>
            <dx-number-box
              [(value)]="amountReceived"
              [step]="0"
              [readOnly]="true"
              [format]="{ type: 'currency', precision: 2 }"
              (onValueChanged)="creditCheck($event)"
              [disabled]="readOnly"
            ></dx-number-box>
          </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'Balance' }">
          <div *dxTemplate>
            <dx-number-box [(value)]="balance" [step]="0" [readOnly]="true" [format]="{ type: 'currency', precision: 2 }" [disabled]="readOnly"></dx-number-box>
          </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'Credit' }">
          <div *dxTemplate>
            <dx-number-box [(value)]="creditAmount" [step]="0" [readOnly]="true" [format]="{ type: 'currency', precision: 2 }" [disabled]="readOnly"></dx-number-box>
          </div>
        </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" caption="QuickBooks Info" [disabled]="true">
        <dxi-item dataField="quickBooksId" [label]="{ text: 'QuickBooks Id' }" [editorOptions]="{ readOnly: true }"> </dxi-item>
        <dxi-item dataField="quickBooksLastExport" [label]="{ text: 'QuickBooks Last Exported' }" [editorOptions]="{ displayFormat: 'shortDateShortTime', readOnly: true }"> </dxi-item>
      </dxi-item>
    </dx-form>
    <!-- <div class="d-flex flex-fill"> -->
    <dx-data-grid
      #invoiceLineGrid
      keyExpr="id"
      height="500px"
      width=""
      class="p-2 me-4 mb-2 flex-fill grid-fill"
      [dataSource]="paymentLines"
      [showBorders]="true"
      [showRowLines]="true"
      (onRowPrepared)="rowPrepare($event)"
      (onRowDblClick)="rowDoubleClick($event)"
      (onRowUpdated)="rowUpdated($event)"
      [customizeColumns]="customizeColumns"
      >
      <dxi-column dataField="lineNumber" caption="No." [visible]="true" width="80" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="description" width="325"></dxi-column>
      <dxi-column dataField="invoiceDueDate" caption="Due Date" width="100" [format]="{ type: 'shortDate' }"></dxi-column>
      <dxi-column dataField="invoiceAmount" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
      <dxi-column dataField="startingBalance" [format]="{ type: 'currency', precision: 2 }" [visible]="key === 'new'" width="100"></dxi-column>
      <dxi-column dataField="remainingBalance" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
      <dxi-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="100" [editorOptions]="{ step: 0 }"></dxi-column>
      <dxi-column dataField="relatedPaymentIds" caption="Related Payments" width="150" cellTemplate="relatedPaymentTemplate"></dxi-column>
      <dxi-column dataField="notes"></dxi-column>
      <div *dxTemplate="let cell of 'relatedPaymentTemplate'">
        @for (paymentId of cell.data.relatedPaymentIds; track paymentId; let i = $index) {
          <span class="pe-1">
            @if (cell) {
              <a [routerLink]="[]" (click)="openPayment(paymentId)">#{{ paymentId + (i + 1 < cell.data.relatedPaymentIds.length ? ", " : "") }}</a>
            }
          </span>
        }
      </div>
      <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing>
      <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="true"></dxo-selection>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="invoice-lines-grid"></dxo-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <!-- <button
        class="btn btn-danger me-2 mb-2"
        (click)="removeInvoiceLine(invoiceLineGrid.instance.getSelectedRowsData()[0])"
        [disabled]="invoiceLineGrid.instance.getSelectedRowsData().length !== 1"
        >
        Clear Payments
      </button> -->
    </div>
    <div *dxTemplate="let data of 'toolbarText'"></div>
  </dx-data-grid>
  <div class="card">
    <dx-form [formData]="payment" [colCount]="2">
      <dxi-item dataField="notes" editorType="dxTextArea" [label]="{ text: 'Payment Memos' }" [editorOptions]="{ height: 100 }"> </dxi-item>
    </dx-form>
  </div>
</div>
}
